import script from "./DeleteConfirmModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DeleteConfirmModal.vue?vue&type=script&setup=true&lang=js"

import "./DeleteConfirmModal.vue?vue&type=style&index=0&id=b6939390&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b6939390"]])

export default __exports__